import {Button, Divider, Flex, Image, Typography} from "antd";
import React, {useState} from "react";
import {useLocale, useTranslations} from "next-intl";
import {LoggerService} from "@/src/services/logger";
import {Locale, usePathname, useRouter} from "@/src/i18n/routing";
import {useParams} from "next/navigation";
import useWindowDimensions from "@/src/hooks/useWindowDimensions";
import {inter} from "@/src/app/fonts";
const { Text, Link } = Typography;

const PrivacyHeaderComponent = () => {
    const localization = useTranslations('header');

    const router: any = useRouter()
    const pathname = usePathname();
    const params = useParams();
    const locale = useLocale();
    const {width, height} = useWindowDimensions()

    const handleLanguageChange = (value: string) => {
        LoggerService.getLogger().debug(`selected ${value}`);
        const nextLocale = value as Locale;

        router.replace(
            {pathname, params},
            {locale: nextLocale}
        );
    };

    return (
        <div style={{fontFamily: `${inter.style.fontFamily}`}}>
            <Flex justify={"space-between"} style={{marginTop: 10}} align={"center"}>
                <Flex justify={"start"} style={{marginTop: 10}} align={"center"}>
                    <Image alt="" src="/assets/place.png" height={32} preview={false} style={{verticalAlign: "unset", width: "auto"}}/>
                    <div style={{margin: "0 10px"}}>
                        <p style={{
                            margin: 0,
                            padding: 0,
                            lineHeight: "normal",
                            fontSize: 14
                        }}>Via 1 Maggio 18</p>
                        <p style={{marginTop: 2, padding: 0, lineHeight: "normal", fontSize: 12}}>Carpignano Salentino, Lecce - Italy</p>
                    </div>
                </Flex>
                <Flex justify={"start"} style={{marginTop: 10}} align={"center"}>
                    <Image alt="" src="/assets/headphones.png" height={32} preview={false} style={{verticalAlign: "unset", width: "auto"}}/>
                    <div style={{margin: "0 10px"}}>
                        <p style={{
                            margin: 0,
                            padding: 0,
                            lineHeight: "normal",
                            fontWeight: 600,
                            fontSize: 14
                        }}>{localization("support")}</p>
                        <p style={{marginTop: 2, padding: 0, lineHeight: "normal", fontSize: 12}}>0039 (0)836 586367</p>
                    </div>
                    <Button
                        className={"languageSelector"}
                        onClick={() => handleLanguageChange(locale == "it" ? "en" : "it")}
                    >
                        {locale == "it" ? "EN" : "IT"}
                    </Button>
                </Flex>



            </Flex>
            <Divider style={{marginTop: 10, marginBottom: 20}}/>
            <Flex align={"center"} justify={"start"}>

                <Flex flex={"fit-content"}>
                    <Link href={"home"}>

                    <Image
                        // height={100}
                        src="/assets/logo.png"
                        preview={false}
                        style={{maxHeight: 110, width: "auto"}}
                        alt=""
                    />
                    </Link>
                </Flex>



            </Flex>
            <Divider style={{marginTop: 20, marginBottom: 20}}/>
        </div>
    );
}

export default PrivacyHeaderComponent